<template>
    <v-app>
        <v-container fluid class="fill-height py-6">
            <v-row align="start" justify="center">
                <v-col cols="12" md="8" lg="7">
                    <v-card :class="mobilePadding">
                        <v-card-text>
                            <v-img
                                :src="require(`@/assets/bgt_logo.jpg`)"
                                height="120px"
                                class="mb-4"
                            />
                            <h1 class="text-h5 mb-2">Privacy Policy</h1>
                            <p class="text-caption text-medium-emphasis mb-6">
                                Last updated: 2 October 2026
                            </p>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Who we are</h2>
                                <p class="text-body-2 text-justify">
                                    Burhani Guards Pakistan operates this system for its members.
                                    For privacy questions, contact
                                    <a href="mailto:admin@bgtpakistan.com">admin@bgtpakistan.com</a>.
                                </p>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Information we hold</h2>
                                <p class="text-body-2 text-justify mb-2">
                                    We hold information in three categories:
                                </p>
                                <ul class="text-body-2 pl-4">
                                    <li class="mb-2">
                                        <strong>Member profile</strong> — identity, contact details,
                                        membership, and health, education, and occupation details kept on
                                        the profile.
                                    </li>
                                    <li class="mb-2">
                                        <strong>Member activity</strong> — attendance, registrations, and
                                        other activity recorded against a member.
                                    </li>
                                    <li class="mb-2">
                                        <strong>Confidential collected data</strong> — answers and other
                                        confidential information submitted through surveys and other forms.
                                        This is separate from the member profile and member activity.
                                    </li>
                                </ul>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Why we hold it</h2>
                                <p class="text-body-2 text-justify">
                                    To administer membership and khidmat, and to carry out the surveys and
                                    forms the organisation asks members to complete.
                                </p>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Who can see it</h2>
                                <ul class="text-body-2 pl-4">
                                    <li class="mb-2">
                                        <strong>Confidential collected data</strong> is available only to
                                        Commander, Secretary, IT Admin, and IT Coordinator.
                                    </li>
                                    <li class="mb-2">
                                        <strong>Member profiles and member activity</strong> may be seen by
                                        incharges within their own place in the hierarchy (for example Team
                                        Incharge and Zone Incharge, and other incharges in that hierarchy),
                                        and only for the members in their charge.
                                    </li>
                                </ul>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Sign-in</h2>
                                <p class="text-body-2 text-justify">
                                    Members sign in through the ITS portal. This system does not use
                                    advertising or analytics trackers. A sign-in session is stored on your
                                    device until you log out. We do not sell personal information.
                                </p>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">How we keep it safe</h2>
                                <p class="text-body-2 text-justify">
                                    The system is not open to the public. Sign-in is required. Access is
                                    limited to the roles described above. Information is available only to
                                    people who need it for their duty.
                                </p>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">How long we keep it</h2>
                                <p class="text-body-2 text-justify">
                                    For as long as you are a member and the organisation needs the record
                                    for its duties.
                                </p>
                            </section>

                            <section class="mb-5">
                                <h2 class="text-h6 mb-2">Your requests</h2>
                                <p class="text-body-2 text-justify">
                                    You may ask to review or correct your profile, or ask how your
                                    information is used, by emailing
                                    <a href="mailto:admin@bgtpakistan.com">admin@bgtpakistan.com</a>.
                                </p>
                            </section>

                            <section class="mb-4">
                                <h2 class="text-h6 mb-2">Changes</h2>
                                <p class="text-body-2 text-justify">
                                    The date at the top of this page shows the current version. We will
                                    update this page if these practices change.
                                </p>
                            </section>

                            <div class="text-center">
                                <v-btn variant="text" to="/login">Back to login</v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useDisplay } from "vuetify";

const { mobile } = useDisplay();

const mobilePadding = computed(() => {
    return mobile.value ? "pa-4" : "pa-8";
});
</script>
